import { render } from "./ModalSizeColor.vue?vue&type=template&id=41bcf900&scoped=true"
import script from "./ModalSizeColor.vue?vue&type=script&lang=js"
export * from "./ModalSizeColor.vue?vue&type=script&lang=js"

import "./ModalSizeColor.vue?vue&type=style&index=0&id=41bcf900&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-41bcf900"

export default script